import * as React from "react";
const SvgFiRrTicketAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 21H5c-2.757 0-5-2.243-5-5v-.922a1 1 0 0 1 1.082-.997c1.106-.021 2-.928 2-2.04s-.894-2.02-2-2.041l-.081.003a1 1 0 0 1-1-1V7.999A5.004 5.004 0 0 1 5 3h14c2.757 0 5 2.243 5 5v1a1 1 0 0 1-1 1c-1.103 0-2 .897-2 2s.897 2 2 2a1 1 0 0 1 1 1v1c0 2.757-2.243 5-5 5M2 15.967V16c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-.126A4.01 4.01 0 0 1 19 12a4.01 4.01 0 0 1 3-3.874V8c0-1.654-1.346-3-3-3H5C3.346 5 2 6.346 2 8v.115a4.05 4.05 0 0 1 3.082 3.926A4.05 4.05 0 0 1 2 15.967"
    />
  </svg>
);
export default SvgFiRrTicketAlt;
